import { useMemo, useContext } from 'react';
import WizardStateContext from 'components/Wizards/shared/context/wizardstate';
import { REPORT_TYPES } from 'components/Wizards/Dashlet/types';

const useShouldExpandModal = (currentDashboard) => {
  const { state } = useContext(WizardStateContext.Context);

  return useMemo(() => {
    const { reportType, customStylesEnabled, area } = state;
    const showColumnBuilder =
      reportType?.value === REPORT_TYPES.SCHEDULED_ACTIVITIES;
    const hasDashboardStyles =
      currentDashboard?.styleSettings &&
      Object.keys(currentDashboard.styleSettings).length > 0;
    const showCustomizedStyles =
      !customStylesEnabled || !area || !reportType
        ? false
        : hasDashboardStyles || customStylesEnabled;

    return showColumnBuilder || showCustomizedStyles;
  }, [state, currentDashboard?.styleSettings]);
};

export default useShouldExpandModal;
